export const HYPERLIQUID_TRANSFER_DOMAIN = {
  name: "HyperliquidSignTransaction",
  version: "1",
} as const;

export const HYPERLIQUID_CENTRAL_ADDRESS = "0x2Df1c51E09aECF9cacB7bc98cB1742757f163dF7";
export const HYPERLIQUID_MIN_DEPOSIT_AMOUNT = 15;
export const HYPERLIQUID_API_LINK = "https://app.hyperliquid.xyz/API";

export const HYPERLIQUID_BALANCE_REFETCH_INTERVAL_MS = 10_000;

// USDC on Arbitrum One
export const ARBITRUM_USDC_ADDRESS = "0xaf88d065e77c8cC2239327C5EDb3A432268e5831" as const;
export const USDC_DECIMALS = 6;
